import { render, staticRenderFns } from "./BasicEduTeacherTraining.vue?vue&type=template&id=006c1581"
import script from "./BasicEduTeacherTraining.vue?vue&type=script&lang=js"
export * from "./BasicEduTeacherTraining.vue?vue&type=script&lang=js"
import style0 from "./BasicEduTeacherTraining.vue?vue&type=style&index=0&id=006c1581&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports